import React from 'react';

import type { RouteObject } from 'react-router-dom';

const AccessesAndRoles = React.lazy(
  () => import('@/pages/UsersDetails/views/AccessesAndRoles'),
);

const UserSessions = React.lazy(
  () => import('@/pages/UsersDetails/views/UserSessions'),
);

export const allUsersDetailsRoutes: RouteObject[] = [
  {
    index: true,
    element: <AccessesAndRoles />,
  },
  {
    path: 'sessions',
    element: <UserSessions />,
  },
];
